import React from 'react';
import Select from 'react-select';
import { Layout } from '../../configs/ui/constant';
import { useTheme } from '@material-ui/core/styles';
import { getCatIconsForCss } from '../../configs/helpers/utility';

const options = [
   // { label: 'All', value: 0 },
   { label: 'Beauty & Health', value: 1 },
   { label: 'Entertainment', value: 2 },
   { label: 'Food & Beverage', value: 3 },
   { label: 'Free', value: 4 },
   { label: 'Hotel & Travel', value: 5 },
   { label: 'Housewares & Electronic', value: 6 },
   { label: 'Limited Edition', value: 7 },
   { label: 'New Arrival', value: 8 },
   { label: 'Bank', value: 9 },
   { label: 'Service', value: 10 },
   { label: 'Sport & Activity', value: 11 },
   { label: 'Survey', value: 12 },
];
const dot = (type = 99) => ({
   alignItems: 'center',
   display: 'flex',
   fill: 'red',

   ':before': {
      content: `url("${getCatIconsForCss(type)}")`,
      display: 'block',
      marginRight: 20,
      height: 30,
      width: 30,
      fill: 'red',
   },
});
function SelectIconsList(props) {
   const theme = useTheme();
   const {
      closeMenuOnSelect,
      onChange,
      isLoading,
      value,
      placeholder,
      isDisabled,
      defaultValue,
      name,
      title,
      alert,
      isMulti,
      onMenuOpen,
   } = props;
   const colourStyles = {
      control: (base, state) => ({
         ...base,
         borderRadius: '5px',
         boxShadow: '',
         // minHeight: '2.2rem',
         '&:focus': {
            border: '1.25px solid',
            borderColor: Layout.primary,
            boxShadow: '',
         },
         '&:hover': {
            border: '1.25px solid',
            borderColor: state.isFocused ? Layout.primary : Layout.primary,
            boxShadow: '',
         },
         border: alert ? '1.25px solid red' : '1.25px solid #d3d2d1',
      }),
      options: (styles, { data }) => ({
         ...styles,
         ...dot(data.value),
      }),
      input: (styles) => ({
         ...styles,
         ...dot(),
      }),
      menu: (base) => ({
         ...base,
         backgroundColor: theme.palette.type === 'dark' ? '#303030' : '#FFFFFF',
      }),
      placeholder: (styles) => ({
         ...styles,
         ...dot(),
      }),
      singleValue: (styles, { data }) => ({
         ...styles,
         ...dot(data.value),
      }),
      indicatorSeparator: (base) => ({
         ...base,
         display: 'none',
      }),
      menuPortal: (base) => ({
         ...base,
         zIndex: 999999,
      }),
   };
   return (
      <Select
         options={options}
         styles={colourStyles}
         onChange={onChange}
         defaultValue={defaultValue && defaultValue}
      />
   );
}

export default SelectIconsList;
